import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import ReverseService from "../../../services/ReverseService";
import CollectOrderService from "../../../services/CollectOrderService";
import TiposColeta from "../../../enums/TiposColeta";
import SgsService from "../../../services/SgsService";
import MinorCollectOrderDetails from './../../molecules/MinorCollectOrderDetails';

export default function InformCollectModal({
  isModalOpen,
  setModalOpen,
  collectOrderId,
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const [collectOrderObject, setCollectOrderObject] = useState();

  useEffect(() => {
    async function fetchRequest() {
      const cOrder = await CollectOrderService.getCollectOrdersById(
        collectOrderId
      );
      setCollectOrderObject(cOrder);
    }

    fetchRequest();


  }, [collectOrderId, isModalOpen]);


  const onSubmit = async (data) => {

    const dataHoraColeta = new Date().toISOString();

    data = { 
      ...data, 
      status: "TRIAGEM", 
      dataHoraColeta: dataHoraColeta
    };

    try {
      await CollectOrderService.updateParcial(collectOrderId, data);
      toast.success("Coleta enviada para triagem");
    } catch (error) {
      toast.error(error.message);
    }

    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-[648px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all mt-6" onClick={(e) => e.stopPropagation()}>
            <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 text-left gap-2 bg-gray-800 rounded-t-lg">
                <div className="text-white text-xl font-bold mt-4">
                  INFORMAR COLETA
                </div>
                <div className="flex justify-between">
                  <div className="text-white text-sm px-4">
                    Coleta:{" "}
                    {collectOrderObject?.collectOrder.idCollectOrder}
                  </div>
                  <div className="text-white text-sm px-4">
                    Ref Solicitação:{" "}
                    {collectOrderObject?.collectOrder.idRequest}
                  </div>
                </div>
              </div>

              <MinorCollectOrderDetails collectOrder={collectOrderObject?.collectOrder} />

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-6">
                <div className="w-full relative inline-block text-left">
                <div className="w-full flex flex-col text-sm gap-4">

                    <div className="flex flex-col items-start gap-1 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Nome Coletor:
                      </label>
                      <input
                        type="text"
                        {...register("nomeColetor", { required: true })}
                        className={`block w-full rounded-lg px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                            ${errors?.nomeColetor?.type === "required"
                            ? " border border-red-500 outline-none ring-0"
                            : "border border-zinc-500 outline-none ring-0"
                          }
                            `}
                      />
                      {errors?.nomeColetor?.type === "required" && (
                        <p className="text-red-500 text-xs ms-2">
                          Campo obrigatório
                        </p>
                      )}
                    </div>

                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Telefone Coletor:
                      </label>
                      <input
                        type="text"
                        {...register("telefoneColetor", { required: true })}
                        className={`block w-full rounded-lg px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                            ${errors?.telefoneColetor?.type === "required"
                            ? " border border-red-500 outline-none ring-0"
                            : "border border-zinc-500 outline-none ring-0"
                          }
                            `}
                      />
                      {errors?.telefoneColetor?.type === "required" && (
                        <p className="text-red-500 text-xs ms-2">
                          Campo obrigatório
                        </p>
                      )}
                    </div>

                    <button
                      onClick={() => handleSubmit(onSubmit)()}
                      className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                    >
                      Enviar
                    </button>


                    {/* <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <div className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Deseja Informar que a Coleta foi feita?
                      </div>
                    </div>

                    <div className="flex gap-4">
                      <button
                        onClick={() => onSubmit(collectOrderObject._id)}
                        className="w-full bg-blue-400 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                      >
                        Sim
                      </button>

                      <button
                        onClick={() => setModalOpen(!isModalOpen)}
                        className="w-full bg-neutral-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                      >
                        Cancelar
                      </button>
                    </div> */}

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

